//CrimeSearch.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as FilterByType from "./FilterByType_Crime";
import * as Geocode from "./Geocode_Crime";
import * as GeoFence_Crime from "./GeoFence_Crime";
import * as Get_Crime from "./Get_Crime";
import * as GraLay from "../Util/GraLay";
import * as HeatMap from "./HeatMap_Crime";
import * as MainMap from "../MainMap";
import * as Search from "../Search/Search";
import * as Settings from "../Settings";
import * as Settings_Crime from "./Settings_Crime";
import * as Spinner from "../Util/Spinner";
import * as TimePeriod_Crime from "./TimePeriod_Crime";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as WidgetHeading from "../Widgets/WidgetHeading";

import { Button, Icon, Paper, Zoom } from "@mui/material";

import React from "react";

//ESRI javascript API.
import AggregateField from "@arcgis/core/layers/support/AggregateField";
import FeatureReductionCluster from "@arcgis/core/layers/support/FeatureReductionCluster";
import PopupTemplate from "@arcgis/core/PopupTemplate";

const toolName: string = "Crime Search";

export let featureLayer: __esri.FeatureLayer = null;
export let featureLayerView: __esri.FeatureLayerView;
export let layer = {} as Search.iLayer; //Crime features.

layer.totRec = 0;
let ss: Settings_Crime.iSS;

//Auto search
export function autoSearch() {
   if (ss.autoSearch) {
      Get_Crime.search();
   }
}

//Clear this tool.
export function clearTool() {
   if (!DrawerMenu.curToolName.startsWith("Crime")) {
      Spinner.hide();
   }
   GeoFence_Crime.clearTool();
}

//Clear results.
export function clearResults(removeAppPoly: boolean = true) {
   layer.totRec = 0;
   layer.fs = null;
   HeatMap.clearHeatMap();
   featureLayer.definitionExpression = "1=2"; //Hide the feature layer results.
   featureLayer.legendEnabled = false;

   if (removeAppPoly) {
      GraLay.appPoly.removeAll(); //Remove the geofence.
   }
}

interface iProps {
   fadeIn: boolean;
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of CrimeSearch.Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did update.
   React.useEffect(() => {
      //Util.errMsg("CrimeSearch did update");
      if (DrawerMenu.curToolName === "Crime Search") {

         //If basemap projection changed, refresh the feature layer.
         MainMap.activeView.watch("spatialReference", function (newSR: __esri.SpatialReference, oldSR: __esri.SpatialReference) {
            if (featureLayer && newSR.wkid !== oldSR.wkid) {
               //Util.errMsg("Refreshing FeatureLayer");
               setTimeout(function () { featureLayer.refresh(); }, 300); //Timeout is required.
            }
         });

         if (!featureLayer) {
            //Util.errMsg("Rebuilding Crime FeatureLayer");
            ss = Settings_Crime.ss; //Get settings.

            //Get crime layer specs.
            layer.spec = Util_App.getLayerSpec(ss.crimePoints_layerName);
            if (!layer.spec) {
               Util.errMsg("Crime points layer spec not found: " + ss.crimePoints_layerName);
               return;
            }

            // Create crime feature layer from map image sublayer.
            if (layer.spec.mapServiceURL.Contains("MapServer")) {
               const crime_mapImageLayer = Util_App.getLayerById(layer.spec.mapServiceID) as __esri.MapImageLayer;
               const crime_subLayer = crime_mapImageLayer.findSublayerById(layer.spec.layerIndex);

               crime_subLayer.createFeatureLayer().then(function (fl) {
                  featureLayer = fl; //Save global feature layer variable.
                  fl.title = "Crime Incidents";
                  fl.minScale = 0;
                  fl.visible = true;
                  fl.definitionExpression = "1=2"; //Hide on startup.
                  fl.listMode = "hide"; //Dont show this working layer in the TOC.
                  fl.legendEnabled = false;
                  fl.orderBy = [{
                     field: "REPORTED_DATE",
                     order: "descending"
                  }];

                  //Create feature reduction cluster and overview of crimes popup.
                  const featureReductionCluster = new FeatureReductionCluster({
                     fields: [
                        new AggregateField({
                           name: "aggregateCount",
                           statisticType: "count"
                        }),
                     ],

                     // Crime summary popup.
                     popupTemplate: new PopupTemplate({
                        title: "Summary of Crimes Near this Location",
                        content: [
                           //{
                           //   type: "text",
                           //   text: "{aggregateCount} crimes at this location."
                           //},
                           {
                              type: "fields",
                              fieldInfos: [
                                 {
                                    label: "Total Crimes",
                                    fieldName: "aggregateCount",
                                    format: { places: 0, digitSeparator: true }
                                 },
                              ] //end fieldInfos.
                           } //end fields.
                        ] //end content.
                     }), //end popupTemplate.

                     //Label the number of crimes inside the circle symbol.
                     labelingInfo: [
                        {
                           labelExpressionInfo: {
                              expression: "$feature.aggregateCount"
                           },
                           symbol: {
                              type: "text",
                              color: "white",
                              font: {
                                 size: "12px"
                              },
                              haloSize: 1.2,
                              haloColor: "black"
                           },
                           labelPlacement: "center-center",
                           deconflictionStrategy: "none",
                        }
                     ], //end labelingInfo
                     clusterMinSize: 32,
                  }); //end new FeatureReductionCluster

                  //Create crime incidents list popup.
                  fl.popupTemplate = new PopupTemplate({
                     title: "{CATEGORY} ({MAJOR_CRIME_CATEGORY}) {REPORTED_DATE}", //Heading for each crime record.
                     content: [
                        {
                           type: "fields",
                           fieldInfos: [
                              { label: "Case Number", fieldName: "CASE_NUMBER" },
                              { label: "Crime Code", fieldName: "CRIME_CODE" },

                              { label: "Address", fieldName: "STREET_ADDRESS" },
                              { label: "Zip Code", fieldName: "ZIPCODE" },
                              { label: "Crime Area", fieldName: "CRIME_AREA" },

                              { label: "Major Crime Category", fieldName: "MAJOR_CRIME_CATEGORY" },
                              { label: "Category", fieldName: "CATEGORY" },
                              { label: "SubCategory1", fieldName: "SUBCATEGORY1" },
                              { label: "SubCategory2", fieldName: "SUBCATEGORY2" },

                              { label: "Section", fieldName: "SECTION" },
                              { label: "Intersection", fieldName: "INTERSECTION" },
                              { label: "Cross Street", fieldName: "CROSS_STREET" },
                              { label: "Beat", fieldName: "BEAT" },
                              //{ label: "Crime", fieldName: "CRIME" },
                           ] //end fieldInfos.
                        },
                     ], //end content.
                  }); //end popupTemplate.

                  fl.load().then(function () {
                     MainMap.map.add(fl); //Add the feature layer to the map.

                     //Util.errMsg("featureReductionCluster", featureReductionCluster);
                     if (MainMap.view2D) {
                        fl.featureReduction = featureReductionCluster;
                     }

                     MainMap.activeView.whenLayerView(fl).then((layerView) => {
                        featureLayerView = layerView; //Save global feature layer view variable.
                        Util.logMsg("featureLayerView", featureLayerView);

                     }).catch(function (error: Error) {
                        Util.errMsg("Error creating feature layer view", error);
                     });

                  }).catch(function (error: Error) {
                     Util.errMsg("Crime feature layer failed to load", error);
                  });

               }).catch(function (error: Error) {
                  Util.errMsg("Failed to create crime feature layer from sublayer", error);
               });

            } else { // Just clone the crime feature layer if already a feature service.
               const fl = Util_App.getLayerById(ss.crimePoints_layerName) as __esri.FeatureLayer;
               featureLayer = fl.clone();
               // Needs work to create feature layer view here when Crime Points are not in MapImage format.
            }

         } //end feature layer is null, etc.
      } //end tool name matched.
   }); //end component did update.

   //Clear search filters.
   function clearFilters() {
      GeoFence_Crime.clearGeoFences();
      FilterByType.setResetAllCrimeTypes(true);
      //TimePeriod_Crime.clearTimePeriod();
      refresh();
   }

   //Close this tool.
   function hide() {
      DrawerMenu.closeTool();
   }

   //Set render values.
   const searchIcon = <Icon color='action'>search</Icon>;
   const clearAllIcon = <Icon color='action'>clear</Icon>;

   const styles: Default.iStyles = {
      appWidgetDiv: { position: 'absolute', top: 0, left: 0, zIndex: 3, minWidth: Settings.leftPanelWidth, overflow: 'auto' },
      paperBeige: { padding: 3, marginTop: 9, backgroundColor: 'beige' },
   };

   const scrollDivID: string = toolName.replace(" ", "_") + "_Scroll";

   return (
      <Zoom in={props.fadeIn} timeout={500}>

         <div id="Crime_Search_Widget" style={styles.appWidgetDiv}>
            <Paper style={{ backgroundColor: "ghostWhite" }}>
               <WidgetHeading.Render title={toolName} onClose={hide} />

               <div id={scrollDivID} style={Default.styles.appToolDiv}>

                  {/*______________________ Geocode address search________________*/}
                  <Paper style={styles.paperBeige}>
                     <Geocode.Render />
                  </Paper>

                  {/*__________________ Crime Search Components _______________*/}
                  <Paper style={styles.paperBeige}>
                     <GeoFence_Crime.Render />
                  </Paper>

                  <Paper style={styles.paperBeige}>
                     <FilterByType.Render />
                  </Paper>

                  <Paper style={styles.paperBeige}>
                     <TimePeriod_Crime.Render />
                  </Paper>

                  {/*_______________________ Action buttons ________________________*/}
                  <div className="app-flex-row-evenly" style={{ marginTop: 9, marginBottom: 9 }}>
                     <Button startIcon={searchIcon} variant="outlined" size="medium" color="info" onClick={Get_Crime.search} title="Search" aria-label="Search">
                        Search
                     </Button>

                     <Button startIcon={clearAllIcon} variant="outlined" size="medium" color="info" onClick={clearFilters} title="Clear filters" aria-label="Clear filters">
                        Clear Filters
                     </Button>
                  </div>

               </div>
            </Paper>
         </div>

      </Zoom>
   ); //end return.

} //end function.
